export enum MaxFileSize {
    FILE_SIZE = 2000000,
    ERROR = "*The file is too big"
}